import { useEffect } from 'react';

import { head } from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';

import Api from 'core/api';
import useUserRedux from 'hooks/useUserRedux';
import { ORG, SCHOOL } from 'routes/constants';
import { ensureObject } from 'utils/objects';

const MemberOrNonLoggedUserEventListRedirect = () => {
  const navigate = useNavigate();
  const { districtId, schoolId } = useParams();

  const { isLoggedIn } = useUserRedux();

  const loggedInUserRedirect = async () => {
    let url = '/';
    const { data } = await Api.organizations.getEmploymentConnections();
    const { uuid } = ensureObject(ensureObject(head(data)).organization);
    url = `${ORG}/${uuid}/event-scheduler/district/${districtId}`;

    if (schoolId) {
      url += `${SCHOOL}/${schoolId}`;
    }

    return navigate(url);
  };

  const nonLoggedInUserRedirect = () => {
    let url = '/';
    url = `/events/district/${districtId}`;
    if (schoolId) {
      url += `${SCHOOL}/${schoolId}`;
    }
    return navigate(url);
  };

  useEffect(() => {
    if (isLoggedIn) {
      try {
        loggedInUserRedirect();
      } catch (e) {
        console.error(e);
      }
    } else {
      nonLoggedInUserRedirect();
    }
  }, []);

  return null;
};

export default MemberOrNonLoggedUserEventListRedirect;
